import instance from "../../utils/instance";

class SkuService {
    async getImportConfirmData(batchId) {
		return await instance.get('/crm/sku/getCacheSku?key=' + batchId);
    }

    async submitImportConfirmData(data,batchId, categoryId) {
		return await instance.post('/crm/sku/importSku',{
			cacheKey:batchId,
			categoryId:categoryId,
			skuDataJson:data
		});
    }
}

export default new SkuService();